import React ,{useEffect,useState} from 'react'
import { pink } from '@mui/material/colors';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import axios from 'axios';
import ApiSetting from '../../../../../../Settings/ApiSettings.json'
import Cookies from "universal-cookie";
import Button from "@mui/material/Button";
import swal from "sweetalert";
import '../../../Dashboard.css'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";

export default function ApprovalesDetials({
    object,mainTransaction,setFormatingStepper,
    FormatingStepper,getAllSectionsForThisTransaction
    ,compleletStage,cureentStageTransactionType,
    income_report_id,setSections,
    setCurrentStageTransactionType,
    setPermissions,setPermissionsForCurrentStage,
    advanceSearch,
    setRenderCheck,
    renderCheck
}) {

   const [allApprovalsData,setAllApprovalsData]=useState([])
   const [finalList,setFinalList]=useState([])
   const [steppsForApproval,setSteppsForApproval]=useState([])
   const [loading,setLoading]=useState(false)
    const allApprovalsDetails=async()=>{
        let data=null;
        try{
            data=await axios({
                method: 'POST',
                url:ApiSetting.apiUrl+'/income_tax_report/getApprovalsForTHisStage',
                data:{
                    stage_transaction_type_id:cureentStageTransactionType?.id,
                    income_report_id:income_report_id,
                    role_id:parseInt(cookies.get('role_id'))+1,
                    user_id:cookies.get('user_id'),
                },
                headers:{
                    'content-type': 'application/json;',
                    'Accept': 'application/json',
                    "X-localization": language,

                }
            })
            if(data){
               if(data?.data?.status==200){
                // swal("نجحت العملية!",`${data?.data?.message}`, "success");
                setAllApprovalsData(data?.data?.data)
               }else{
                swal("فشلت العملية!",`${data?.data?.message}`, "warning");
            }
            }
        }catch(err){
            swal("فشلت العملية!",`${err?.message}`, "error");
        } 
    }
    useEffect(()=>{
        if(cureentStageTransactionType?.id)
         allApprovalsDetails()
        console.log(cureentStageTransactionType?.id)

    },[cureentStageTransactionType?.id])

    useEffect(()=>{
        if(allApprovalsData?.length>0){
            let arr=[];
            allApprovalsData?.map((data)=>{
                let check1=false;
                let check2=false;
                let check3=false;

                if(data?.transaction_approval?.approval_status_id==2)
                   check1=true;
                else if(data?.transaction_approval?.approval_status_id==1)
                  check2=true;
                else if(data?.transaction_approval?.approval_status_id==3)
                check3=true;

              arr.push({
                id:data?.id,
                stage_transaction_type_id:data?.stage_transaction_type_id,
                is_mandatory:data?.is_mandatory,
                approvedLiset:{
                    approve:check1,
                    notApprove:check3,
                    inProgress:check2,
                },
                role_id:data?.role_id,
                role_name:data?.role?.name
              })
            })
            setFinalList(arr)
        }
    },[allApprovalsData])

    const changeApprova=(id,check)=>{
           let arr=[];
           finalList?.map((data)=>{
              if(data?.id==id){
                let approve=check;
                let notApprove=false;
                let inProgress=false;

                arr.push({
                    ...data,
                    approvedLiset:{
                        approve:approve,
                        notApprove:notApprove,
                        inProgress:inProgress,
                    }
                })
              }else{
                arr.push(data)
              }

           },[])
        setFinalList(arr)

    }

    const changeNotApprova=(id,check)=>{
        let arr=[];
        finalList?.map((data)=>{
           if(data?.id==id){
                let approve=false;
                let notApprove=check;
                let inProgress=false;

             arr.push({
                 ...data,
                 approvedLiset:{
                    approve:approve,
                    notApprove:notApprove,
                    inProgress:inProgress,
                 }
             })
           }else{
            arr.push(data)
          }

        },[])
        setFinalList(arr)
    }

    const changeInProgress=(id,check)=>{
        let arr=[];
        finalList?.map((data)=>{
           if(data?.id==id){
            let approve=false;
            let notApprove=false;
            let inProgress=check;
             arr.push({
                 ...data,
                 approvedLiset:{
                    approve:approve,
                    notApprove:notApprove,
                    inProgress:inProgress,
                 }
             })
           }else{
            arr.push(data)
          }

        },[])
        setFinalList(arr)

    }

    const storeData=async()=>{
        swal({
            title: "هل انت موافق?",
            text: "بمجرد ضغطك للزر سيتم المصادقة على هذا المرحلة!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            })
            .then(async(willDelete) => {
                if (willDelete) {
                    let data=null;
                    try{
                        data=await axios({
                            method: 'POST',
                            url:ApiSetting.apiUrl+'/income_tax_report/storeApprovalsData',
                            data:{
                                stage_transaction_type_id:cureentStageTransactionType?.id,
                                role_id:parseInt(cookies.get('role_id'))+1,
                                user_id:cookies.get('user_id'),
                                list:finalList,
                                income_report_id:income_report_id,
                            },
                            headers:{
                                'content-type': 'application/json;',
                                'Accept': 'application/json',
                                "X-localization": language,
                            }
                        })
                        if(data){
                            if(data?.data?.status==200){
                                // swal("نجحت العملية!",`${data?.data?.message}`, "success");
                                swal(`${data?.data?.message}`, {
                                    icon: "success",
                                });
                                if(data?.data?.data){
                                    getSectionsFromRequest(data?.data?.data)
                                }
                            }else{
                                swal("فشلت العملية!",`${data?.data?.message}`, "warning");
                            }
                        }
                    }catch(err){
                        setLoading(false)
                        swal("فشلت العملية!", `${err?.message}`, "error");

                    }
                }
            });
    }

    const getSectionsFromRequest=(data)=>{
       

        let arr=[]
        let arr2=[]
        if(data?.list?.length>0){
            data?.list?.map((itm)=>{
                arr.push(itm?.section)
                arr2.push({per:itm?.permissions,section_id:itm?.section?.id})

            })
            setSections(arr)
            setPermissions(arr2)
            setCurrentStageTransactionType(data?.currentStage)
            setPermissionsForCurrentStage(false)
            advanceSearch()
            setRenderCheck(!renderCheck)
        }else{
        setSections([])
        setPermissions([])
        setCurrentStageTransactionType(data?.currentStage)
        setPermissionsForCurrentStage(false)
        }
      
    }

    useEffect(()=>{
        console.log('complete stage=> ',compleletStage)
    },[compleletStage])

    useEffect(()=>{
        let arr=[];
    
        let counter_step=0;
        let arr_sections=[];
   
        mainTransaction?.transaction_type?.stage_transaction_type?.map((stageTraType)=>{
            let arr_2={}
            let count_check=0;
            let count_check_tow=0;
            let count_check_rejected=0;
            let status=false;
            let status_reject=false;
            let arr_appr=[];
            stageTraType?.transaction_approval?.map((approv)=>{
                if(mainTransaction?.id==approv?.transaction_id){
                    if(approv?.approval_status?.id==2|| approv?.stage_transaction_type_approval?.is_mandatory==0){
                      count_check++;
                      arr_appr.push({
                        id:approv?.stage_transaction_type_approval?.role?.id,
                        name:approv?.stage_transaction_type_approval?.role?.name,
                        status:true,

                      })
                    }

                    if(approv?.approval_status?.id==3&&approv?.stage_transaction_type_approval?.is_mandatory==1){
                     count_check_rejected++;
                     arr_appr.push({
                        id:approv?.stage_transaction_type_approval?.role?.id,
                        name:approv?.stage_transaction_type_approval?.role?.name,
                        status:false,
                      })
                    }
                    count_check_tow++
                }
            })

            if(count_check==count_check_tow&&count_check==stageTraType?.stage_transaction_type_approval?.length){
            status=true;
            }

            if(stageTraType?.stage_transaction_type_approval?.length==0){
            status=true;
            }

            if(status){
            counter_step=arr.length+1;
            }

            if(count_check_rejected>0){
            status=7
            }

            if(mainTransaction?.stage_transaction_type?.id==stageTraType?.id){

            // if(status!==7)
            // setCompleteStage(status)
            }

        
            arr_2={
            income_report_id:object?.id,
            transactions_id:mainTransaction?.id,
            transaction_type_id:mainTransaction?.transaction_type?.id,
            stage_name:stageTraType?.stage?.name,
            stage_id:stageTraType?.stage?.id,
            stage_transaction_type_id:stageTraType?.id,
            order_number:stageTraType.order_number,
            status:status,
            approval_list:arr_appr
            }
            arr.push(arr_2) 
    })

    setSteppsForApproval(arr)
     
    },[mainTransaction,cureentStageTransactionType?.id])



  return (
    <div className="container-fluid px-0 mx-0">
        <div className="row ">
        {
            finalList?.map(data=>(

           <div className="col-md-6 my-2">
                <div className='d-flex align-items-center'>
                    <h4 style={{
                        fontSize:'18px',
                        margin:'0 10px',
                        width:'25%',
                    }}>{data?.role_name} </h4>
                    <FormGroup sx={{
                        display: 'flex',
                        flexDirection:'row' ,
                        border:'1px solid green',
                        padding:'10px',
                        borderRadius:'5px',
                        }}>
                    
                            <FormControlLabel
                                control={<Checkbox {...label}  checked={data?.approvedLiset?.approve}
                                disabled={(parseInt(cookies.get('role_id'))+1)==data?.role_id&&!compleletStage?false:true}
                                onChange={(e)=>{
                                    changeApprova(data?.id,e.target.checked)
                                }}/>}
                                label="موافق"
                            />
                            <FormControlLabel
                                control={<Checkbox {...label} checked={data?.approvedLiset?.inProgress}
                                disabled={(parseInt(cookies.get('role_id'))+1)==data?.role_id&&!compleletStage?false:true}
                                onChange={(e)=>{
                                    changeInProgress(data?.id,e.target.checked)
                                }} />}
                                label="فال الانتظار"
                            />
                            <FormControlLabel
                                control={<Checkbox {...label} checked={data?.approvedLiset?.notApprove}
                                disabled={(parseInt(cookies.get('role_id'))+1)==data?.role_id&&!compleletStage?false:true}
                                onChange={(e)=>{
                                    changeNotApprova(data?.id,e.target.checked)

                                }} />}
                                label="غير موافق"
                            /> 
                    
                    </FormGroup>
                </div>
            </div>  
           ))
        }

        <div className="col-md-12">
            <div
            style={{
                display: "flex",
                marginTop: 10,
                backgroundColor: "#fefefe",
                paddingLeft: 10,
                paddingRight: 10,
                paddingBottom: 30,

                justifyContent: "space-evenly",
                alignItems: "center",
            }}
            >
            

            <Button
                variant="contained"
                style={{
                backgroundColor: "#5f7b8a",
                width: "40%",
                fontSize: "20px",
                }}
                onClick={()=>{
                    storeData()
                }
                }
            >
                {!loading ? (
                'تحديث'
                ) : (
                <div className="spinner-border " role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                )}
            </Button>
            </div>
        </div>

        {
            cureentStageTransactionType?.id==4?
            steppsForApproval?.map((data)=>(
                data?.status?
                <List sx={{ width: '45%', bgcolor: 'background.paper',margin:'20px 0' }} className="cardList">
                    <Typography>
                        {" المرحلة: "+ data?.stage_name} 
                    </Typography>
                    {
                        data?.approval_list?.map((user)=>(
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                <Avatar alt="Remy Sharp" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkvuuqLsIvmV4xUofpu3hAjw6G4iKHs34BMg&usqp=CAU" />
                                </ListItemAvatar>
                                <ListItemText
                                primary={`@${user?.name}`}
                                secondary={
                                    <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                    >
                                         {/* {user?.name} */}
                                    </Typography>
                                      
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        color={user?.status?"text.primary":'red'}
                                    >
                                    {
                                        user?.status?"  تم الموافقة على هذه المرحلة من قبل " +user?.name:
                                        "  تم رفض الموافقة على هذه المرحلة من قبل " +user?.name
                                    }
                                    </Typography>
                                    </React.Fragment>
                                }
                                />
                            </ListItem>
                       ))
                    }
               
                </List>:null
                    
              ))
             :null
        }

        

        </div>
    </div>
  )
}
